/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionTypeEnumV2 = 'TRIAL' | 'PAID';

export const SubscriptionTypeEnumV2 = {

    TRIAL: 'TRIAL' as SubscriptionTypeEnumV2,

    PAID: 'PAID' as SubscriptionTypeEnumV2
};

